module.exports = require('./helpers/bundle-url').getBundleURL('9U9Lq') + "foto-marcelo.f9c79cae.png";